import React from "react"
import Money from "../../../Money"
import DineroFactory from "dinero.js"
import {
  OrderLineDiscount,
  OtherDiscount,
  TotalDiscount,
  TotalDiscountContainer
} from "./Shared.styled"
import { useOrderTabContext } from "../../../../views/Orders/OrderViews/OrderTabContext"

type Props = {
  discountsExclProductDiscount: number
  totalDiscount: number
  currencyCode: string
  salePriceAmount: number
}

const Total = ({ totalDiscount, currencyCode, salePriceAmount, discountsExclProductDiscount }: Props) => {
  const { switchToDiscountTab } = useOrderTabContext()

  const getPercentage = (discountAmount: number, salePriceAmount: number) => {
    return ((discountAmount / salePriceAmount) * 100).toFixed(0)
  }

  const otherDiscount = discountsExclProductDiscount - totalDiscount

  if(totalDiscount === 0) return null

  return (
    <TotalDiscountContainer>
      <OrderLineDiscount><div>Total percentage</div> <div>{getPercentage(discountsExclProductDiscount, salePriceAmount)}{"%"}</div></OrderLineDiscount>
      {otherDiscount > 0 && <OrderLineDiscount>
        <OtherDiscount onClick={switchToDiscountTab}>Other discounts</OtherDiscount>{" "}
        <Money amount={discountsExclProductDiscount - totalDiscount} currencyUnit={currencyCode as DineroFactory.Currency} />{" "}
      </OrderLineDiscount>}
      <TotalDiscount>
        <div>Discounts total</div>{" "}
        <Money amount={discountsExclProductDiscount} currencyUnit={currencyCode as DineroFactory.Currency} />{" "}
      </TotalDiscount>
    </TotalDiscountContainer>
  )
}

export default Total
